import { PoposedToTheSubCommittee3FormContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee3FormContainer";
export function PoposedToTheSubCommittee3FormPage () {

    return(
        <PoposedToTheSubCommittee3FormContainer/>
    )
}




